import React, { FC, ReactNode } from "react";
import { Link as KLLink, LinkIconAnimation } from "kaleidoscope/src";
import { navigate } from "gatsby";

interface LinkProps {
  href?: string;
  rel?: string;
  target?: string;
  className?: string;
  onClick?: (event?: any) => void;
  iconStart?: ReactNode;
  iconEnd?: ReactNode;
  iconAnimation?: LinkIconAnimation;
  id?: string;
}

const Link: FC<LinkProps> = ({ href, onClick, ...props }) => {
  const isInternal = !href.includes("://") && !href.includes("mailto:");

  const handleNav = (): void => {
    navigate(href);
    onClick?.();
  };

  if (isInternal) {
    return <KLLink onClick={handleNav} {...props} />;
  }

  return <KLLink href={href} onClick={onClick} {...props} />;
};

export default Link;
